import LoyaltyLevelRewardButton from "components/molecules/LoyaltyLevelRewardButton";
import { RANK_LEVEL_LOYALTY_IMAGES } from "constants/loyalty";
import "./styles.sass";
import { LoyaltyTagStatusVariantT } from "../../atoms/LoyaltyTagStatusRank/types";

type LoyaltyListRanksProps = {
  onClickCard: (index: number) => void;
  ranks?: Array<{ name: string; statusRank: LoyaltyTagStatusVariantT }>;
};

const LoyaltyListRanks = (props: LoyaltyListRanksProps) => {
  const { ranks = [], onClickCard } = props;
  return (
    <div className="LoyaltyListRanks">
      {ranks?.map((rank, index) => (
        <LoyaltyLevelRewardButton
          key={rank.name}
          rankName={rank.name}
          handleClick={() => onClickCard(index)}
          image={RANK_LEVEL_LOYALTY_IMAGES[index].rank}
          status={rank.statusRank}
        />
      ))}
    </div>
  );
};

export default LoyaltyListRanks;
